<div class="register-container">
    <!--Banner starts here-->
    <section id="banner" class="banner">
         <div class="container">
        <div class="banner__logos">
            <div><img src="./assets/images/ust_logowhite.png" class="banner__logosz" alt="ust-logo"> </div>
        <div class="banner__logolabel"> - Licensing App</div>
        </div>

        <div class="banner__main">
          <div class="banner__mainlabel">
            Forgot Password   
          </div>
          <form>
          <div>Enter your Email Address or User Name below and we'll send you a temporary password.</div><br>
            <div class="row" style="margin-bottom: 20px">
              <div class="col-md-12 col-lg-12 col-sm-12">
               <div class="input-group">
                               
                    <span class="input-group-addon" id="sizing-addon2"><img src="assets/images/mail_new.png" style="width: 16px;"></span>
                    <input type="text" class="form-control" name="emailAddress"  [(ngModel)] ="user" placeholder="Email or User Name" >
                </div>
            </div>
            </div>
          
            <button type="submit"  class="banner__btncustom" (click)="forgotConfirm()"
            >Submit</button>
            
          </form>
          <div class="banner__signup">
            <div><a href="./index.html" style="color:#006e74">Back to Login</a></div>
          </div>
        </div>
      </div> 
        
        </section>
  </div>
  